import { doRequest } from '@r1-frontend/do-request';
import getHousesList from '@r1-frontend/api-domru/api-profile/v1/address/get-house-list';

import { ICitiesOption, ISelectInputOption } from '@r1-frontend/shared/types/ISelectInputOption';

import { parseGetHousesResp } from '~/src/components/SmartHome/order/videocontrol';

import {
    EActionTypes,
    getInitialState,
    IAddressFieldsState,
    TSetData,
    TSetFlat,
    TSetHouseList,
    TSetHouseText,
    TSetSelectedCity,
    TSetSelectedHouse,
    TSetSelectedStreet,
    TSetStreetText,
} from './reducer';

const initState = getInitialState({});

export const setSelectedCity = (option: ICitiesOption | null): TSetSelectedCity => ({
    type: EActionTypes.SET_SELECTED_CITY,
    payload: {
        ...initState,
        selectedCity: option,
    },
});

export const setStreetText = (text: string): TSetStreetText => ({
    type: EActionTypes.SET_STREET_TEXT,
    payload: {
        streetText: text,
    },
});

export const setSelectedStreet = (option: ISelectInputOption | null): TSetSelectedStreet => ({
    type: EActionTypes.SET_SELECTED_STREET,
    payload: {
        selectedStreet: option,
        houseText: '',
        selectedHouse: null,
        flat: '',
    },
});

export const setHouseText = (text: string): TSetHouseText => ({
    type: EActionTypes.SET_HOUSE_TEXT,
    payload: {
        houseText: text,
    },
});

export const setSelectedHouse = (option: ISelectInputOption | null): TSetSelectedHouse => ({
    type: EActionTypes.SET_SELECTED_HOUSE,
    payload: {
        selectedHouse: option,
        flat: '',
    },
});

export const setHouseList = (list: ISelectInputOption[]): TSetHouseList => ({
    type: EActionTypes.SET_HOUSE_LIST,
    payload: {
        houseList: list,
    },
});

export const fetchHouseList = async(streetId: number): Promise<ISelectInputOption[]> => {
    const resp = await doRequest.apiProfile(getHousesList({ streetId }));
    if (resp.isSuccess) {
        console.log(resp.payload);
        const list = parseGetHousesResp(resp.payload);
        return list.map(el => ({ value: el.id, label: el.number }));
    } else {
        return [];
    }
};

export const setFlat = (text: string):TSetFlat => ({
    type: EActionTypes.SET_FLAT,
    payload: {
        flat: text,
    },
});

export const setData = (data: Partial<IAddressFieldsState>): TSetData => {
    return ({
        type: EActionTypes.SET_DATA,
        payload: {
            ...data,
        },
    });
};
